module.exports = __webpack_public_path__ + "img/东莞市友安金属.6cd960cd.jpg";